export const dealDefaultFieldData = (fields, data) => {
  const objData = {}
  if (fields) {
    fields.forEach((obj) => {
      if (data && data[obj.slug]) {
        const value = data[obj.slug]
        objData[obj.slug] = value
      } else {
        if (obj.default && obj.default.value) {
          objData[obj.slug] = obj.default.value
        }

        if (obj.defaultChecked) {
          objData[obj.slug] = obj.defaultChecked
        }
      }
    })
  }
  return objData
}
